import styled, { CSSProperties } from 'styled-components';

export const DotBadge = ({ style }: { style?: CSSProperties }) => {
  return <Dot style={{ ...style }} />;
};

const Dot = styled.span`
  position: absolute;
  top: -3px;
  right: -3px;

  display: block;

  width: 8px;
  height: 8px;
  border-radius: var(--radius-medium, 8px);
  background-color: #ff3049;
`;
